// extracted by mini-css-extract-plugin
export var maindiv = "blogTile-module--maindiv--sj+n6";
export var hoverOverMe = "blogTile-module--hoverOverMe--Jm7aY";
export var imgDiv = "blogTile-module--imgDiv--qvpFG";
export var midImgDiv = "blogTile-module--midImgDiv--nLpDn";
export var img = "blogTile-module--img--D-TNA";
export var sideDiv = "blogTile-module--sideDiv--b2ARi";
export var name = "blogTile-module--name--I8rNS";
export var desc = "blogTile-module--desc--nTKx8";